import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import translatePropTypes from '../../../translatePropTypes';
import withEditSession from '../../containers/EditSessionProvider/withEditSession';
import { CommonTreeSelectorContext } from '../../controls/CommonTreeSelector/CommonTreeSelectorContext';
import withTranslations from '../../utils/Translations/withTranslations';
import { CommonStaticTree } from '../BasicTrees';
import StaticTreeStaticBodyContent from '../StaticTree/StaticTreeStaticBodyContent';
import StaticOverlayTreeDefaultFilter from './StaticOverlayTreeDefaultFilter';

@withTranslations
@withEditSession
export default class StaticOverlayTree extends CommonStaticTree {
  static propTypes = {
    ...CommonStaticTree.propTypes,
    ...translatePropTypes,

    filterSelection: PropTypes.func,
    hasSearchFieldOnly: PropTypes.bool,
  };

  static defaultProps = {
    ...CommonStaticTree.defaultProps,
    hasSearchFieldOnly: true,
    filterSelection: null,
  };

  get filter() {
    const {
      hasFilter,
      hasSearchFieldOnly,
      filter: { component },
    } = this.props;

    if (!hasFilter) {
      return null;
    }

    const FilterBarComponent = component || StaticOverlayTreeDefaultFilter;

    return (
      <FilterBarComponent
        hasSearchFieldOnly={hasSearchFieldOnly}
        value={this.props.filter.value || this.state.filter}
        onChange={this.handleFilterChange}
      />
    );
  }
  get modelsWithChilds() {
    const { tree } = this.props;
    if (tree === 'OrgStructureGroupsTreeSelectorField') {
      let organisationStructureGroupIds = [];
      organisationStructureGroupIds = this.models
        .filter(
          model =>
            model.__typename === 'OrganisationStructureGroup' &&
            model.orgStructLevelId,
        )
        .map(model => model.orgStructLevelId);

      let parentIds = [];
      parentIds = this.models
        .filter(
          model =>
            model.__typename === 'OrgStructureLevel' && model.parentId !== null,
        )
        .map(model => model.parentId);
      let filteredModels = [];
      filteredModels = this.models;

      while (true) {
        filteredModels = filteredModels.filter(model => {
          if (model.id === ':ROOT:') return true;
          else if (model.__typename === 'OrganisationStructureGroup')
            return true;
          else if (
            model.__typename === 'OrgStructureLevel' &&
            (organisationStructureGroupIds.includes(model.id) ||
              parentIds.includes(model.id))
          )
            return true;
          return false;
        });
        const tempParentIds = filteredModels
          .filter(
            model =>
              model.__typename === 'OrgStructureLevel' &&
              model.parentId !== null,
          )
          .map(model => model.parentId);
        if (tempParentIds.length >= parentIds.length) break;
        else parentIds = tempParentIds;
      }
      return filteredModels;
    }
    return this.models;
  }
  handleOnChange = items => {
    const { onSelectionChange, filterSelection } = this.props;

    if (isArray(items)) {
      return filterSelection
        ? onSelectionChange(filterSelection(items))
        : onSelectionChange(items);
    }

    const [item] = filterSelection ? filterSelection([items]) : [items];
    onSelectionChange(item);
  };

  getTreeBody = plugins => {
    const {
      tree,
      filter: { value: filterValue },
      value,
      handleClear,
    } = this.props;

    const { filter: stateFilterValue } = this.state;

    return (
      <CommonTreeSelectorContext.Consumer>
        {({ setMainTreeModels }) => (
          <StaticTreeStaticBodyContent
            adapter={this.state.adapter}
            filter={{
              value: filterValue || stateFilterValue,
              predicatesMeta: this.predicatesMeta(),
            }}
            getMainTreeChildrenCounts={this.getMainTreeChildrenCounts}
            handleClear={handleClear}
            inflateInitialExpansion={this.inflateInitialExpansion}
            models={this.modelsWithChilds}
            nodeShouldBeInitiallyVisible={this.nodeShouldBeInitiallyVisible}
            plugins={plugins}
            rootModels={this.rootModels}
            selection={value}
            setMainTreeChildrenCounts={this.setMainTreeChildrenCounts}
            setMainTreeModels={setMainTreeModels}
            tree={tree}
            onSelectionChange={this.handleOnChange}
          />
        )}
      </CommonTreeSelectorContext.Consumer>
    );
  };

  render() {
    const plugins = this.makePlugins();

    const { children } = this.props;
    const { adapter } = this.state;

    const body = this.getTreeBody(plugins);

    return children ? (
      children(body, this.filter, null, plugins, adapter, {})
    ) : (
      <>
        {this.filter}
        <div className="row">
          <div className="col-xs-12">{body}</div>
        </div>
      </>
    );
  }
}
